// extracted by mini-css-extract-plugin
export default {"table":"Board_table__8uWd-"};